<script>
  import { ShopBoxAdminApp } from '@shopboxai/shopbox-admin-app';
  import { currentUser, currentClientWebsite } from '../stores';
</script>

<ShopBoxAdminApp user={$currentUser} website={$currentClientWebsite} />
